import React, {Fragment, useState} from 'react';
import { Dialog, Transition } from "@headlessui/react";
import { Link } from "react-router-dom";
import SideWave from "../assets/sideWave.png";



const HeaderModal = ({isOpen, isClose}) => {
  return (
    <>
     <Transition appear show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={isClose}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-[60%] transform overflow-hidden rounded-2xl bg-[#E0EDF5] p-6 text-left align-middle shadow-xl transition-all">
                  <div className="flex justify-center">
                    <div className="w-[80%] h-[500px] rounded-lg bg-[#E0EDF5]">
                      <div className="p-2">
                      <div className="">
                      <div className="text-center p-3 mt-4 font-bold text-lg">
                        {" "}
                        Resources
                      </div>

                      <div className="flex justify-between">
                        <div className="flex flex-col justify-center gap-2">
                          <Link to="/aboutus">
                            <p className="flex p-8 gap-1 ml-8 items-center font-bold">
                              About Us
                            </p>
                          </Link>
                          <Link to="/contactus">
                            <p className="flex p-8 gap-1 ml-8 items-center font-bold">
                              Contact Us
                            </p>
                          </Link>

                          <Link to="/blog">
                            <p className="flex p-8 gap-1 ml-8 items-center font-bold">
                              Blog
                            </p>
                          </Link>
                        </div>
                        <div className="hidden md:flex md:w-[400px] md:h-[400px]">
                          <img
                            src={SideWave}
                            alt="lemon"
                            className="w-full h-full object-fit rounded-[20px]"
                          />
                        </div>
                      </div>
                    </div>
                      </div>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  )
}

export default HeaderModal